export default {
  PASSED: 'passed',
  FAILED: 'failed',
  NOT_PERFORMED: 'not_performed',
  NOT_APPLICABLE: 'not_applicable',
  DECLINED: 'declined',
  APPROVED: 'approved',

  AUTOAPPROVED: 'AUTOAPPROVED',
  NEEDSAPPROVAL: 'NEEDSAPPROVAL',
  MANUALAPPROVED: 'MANUALAPPROVED',
  MANUALREJECTED: 'MANUALREJECTED',
};
